var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 12",
    fill: "#366C05",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.072876,
    y: 0.0175781,
    width: 2,
    height: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07288,
    y: 0.0175781,
    width: 2,
    height: 12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0729,
    y: 0.0175781,
    width: 2,
    height: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalHamburger);
export default __webpack_public_path__ + "static/media/vertical-hamburger.63de13de55efd4fefcea8202f583ceb2.svg";
export { ForwardRef as ReactComponent };